import { Component, OnInit, ErrorHandler } from '@angular/core';
import { RegistrationService } from '../../../registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';


@Component({
  selector: 'app-budget-form',
  templateUrl: './budget-form.component.html',
  styleUrls: ['./budget-form.component.css']
})
export class BudgetFormComponent implements OnInit {
  maintitle = "Budget";
  title = "Add Budget";

  modelDate = '';
  accountheadsubheadlist:any=[];
  b:any={};
  bs:any={};
  formInvalid: boolean;
  data: any;
  formSubmitted: boolean;
  test :any=[];
  Budget_Year: any;
  mode: any;
  Budget_Id: any;
  budgetTotalamt: any=0;

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) { }

  ngOnInit() {
    // this.route.params.subscribe(params => {
    //   this.Budget_Id  = params['Budget_Id'],
    //   this.Budget_Year = params['Budget_Year']
    //   this.mode = params['mode']
    // });
     //From URL
     this.mode=localStorage.getItem('mode');
     this.Budget_Id = localStorage.getItem('budgetId');
     this.Budget_Year = localStorage.getItem('budgetyear');
     localStorage.removeItem('budgetId'); 
     localStorage.removeItem('budgetyear'); 
     localStorage.removeItem('mode');

     if(this.mode=='view')
     {
       this.title="View Budget";
     }
     if(this.mode=='edit'){
      this.title="Edit Budget";
     }
     

    if (this.Budget_Year != null && this.mode!=null) 
    {
      this.GetBudgetDetailsByYear(this.Budget_Year);
    }

   else if(this.mode!='view' || this.mode!='edit')
   {
     if(this.b.Budget_Year!=undefined || this.b.Budget_Year!=null )
      this.GetAllAccountHeadSubHeadForBudget(this.b.Budgetyear);
   }


  }  

  onOpenCalendar(datepicker) {
    datepicker.yearSelectHandler = (event: any): void => {
      datepicker._store.dispatch(datepicker._actions.select(event.date));
    };     
    datepicker.setViewMode('year');
  }


  ngAfterViewInit(){
    var year = 2010;
    var till = 2050;
    var options = "";
    for(var y=year; y<=till; y++){
      options += "<option>"+ y +"</option>";
    }
    document.getElementById("year").innerHTML = options;
  }


  // GetAllAccountHeadSubHeadForBudget()
  GetAllAccountHeadSubHeadForBudget(BudgetYear)
  {
    ;
    this.CheckBudgetYearAlreadyExist(BudgetYear);
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllAccountHeadSubHeadForBudget()
      .subscribe(
        (data) => { 
          this.accountheadsubheadlist= data;
         // console.log('subheadlist',this.accountheadsubheadlist);     
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  //SaveBudgetDetails
  //SaveBudgetDetails(budgetForm:NgForm) {    
    SaveBudgetDetails(b) {
      // ;  
      // for (let i=0;i<=this.accountheadsubheadlist.length;i++)  
      // {
      //   for(let j=0;j<=this.accountheadsubheadlist[i].AccountSubHeadDetails;j++)
      //   {
      //   this.budgetTotalamt=this.accountheadsubheadlist[i].AccountSubHeadDetails[j].Budget_Amount+this.budgetTotalamt;
      //   }
      // }
      // if(this.budgetTotalamt>0)
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.b.BudgetModel=this.accountheadsubheadlist;
      //budgetForm.value.BudgetModel=this.accountheadsubheadlist;
      this.data = this.userService.SaveBudgetDetails(this.b.BudgetModel,this.b.Budget_Year);
      //this.data = this.userService.SaveBudgetDetails(budgetForm.value.BudgetModel,this.b.Budget_Year);
      this.data.subscribe(
        (response) => {
          this.formInvalid = false;
          swal('Success!', 'Budget details saved successfully.', 'success');
          this.router.navigate(['/home/budget']);
          //budgetForm.resetForm();
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
    }


    GetBudgetDetailsByYear(Budget_Year) {
       document.getElementById('loader-spinner').style.display = "block";
       this.userService.getBudgetDetailsByYear(Budget_Year)
         .subscribe(
           (data) => {
            // this.b = data;
             //this.accountheadsubheadlist= data;
             this.test=data;

             //working
             this.accountheadsubheadlist = data;
             this.b.Budget_Year=data[0].AccountSubHeadDetails[0].Budget_Year;   
             document.getElementById('loader-spinner').style.display = "none";
           }, (error) => {
             document.getElementById('loader-spinner').style.display = "none";
             this.errorHandler.handleError(error);
           });
     }
 


    // UpdateBudgetDetails(budgetForm:NgForm) {
      UpdateBudgetDetails(b:any) {
     // if (!budgetForm.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      this.b.BudgetModel=this.accountheadsubheadlist;
      this.userService.updateBudgetDetails(this.b.BudgetModel,this.b.Budget_Year)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('','Updated Successfully!','success');
            this.router.navigate(['/home/budget']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.handleError(error);
            //swal('Warning!', error.error.Message, 'warning');
          });
        // }else{
        //   document.getElementById('loader-spinner').style.display = "none";
        //   swal('warning','Please fill all the mandatory fields!','warning');
        //   this.formSubmitted = true;
  
        //   }
    }


    CheckBudgetYearAlreadyExist(BudgetYear){
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.checkBudgetYearAlreadyExist(BudgetYear);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          console.log(error);
          //if (error.Message == "")
          //if(error.status==400)
          swal("Warning!", "Specified Budget Year already exist", "warning");
        });
    }



  
}



// WEBPACK FOOTER //
// ./src/app/finance/budget/budget-form/budget-form.component.ts